import React from "react";
import { FaCreditCard, FaSave } from "react-icons/fa";

export default function PaiementHeader({ formId, loading, saving }) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-5 sm:p-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Gestion
            </p>

            <h2 className="mt-1 flex items-center gap-3 text-2xl font-bold text-slate-900 dark:text-white">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
                <FaCreditCard />
              </span>
              Paramètres de paiement
            </h2>

            <p className="mt-2 max-w-4xl text-sm leading-6 text-slate-600 dark:text-slate-300">
              Définissez le nombre maximum d’échéances, l’espacement entre les
              paiements et l’image par défaut utilisée pour le règlement
              Licence-Assurance & Cotisation.
            </p>
          </div>

          <button
            type="submit"
            form={formId}
            disabled={loading || saving}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#013E8E] px-4 py-3 text-sm font-bold text-white shadow-sm transition hover:bg-[#012f6d] disabled:cursor-not-allowed disabled:opacity-60 dark:bg-indigo-500 dark:hover:bg-indigo-400"
          >
            <FaSave />
            {saving ? "Enregistrement..." : "Enregistrer"}
          </button>
        </div>
      </div>
    </section>
  );
}